export const useNotificationsStore = defineStore('notifications', () => {
    const count = ref(undefined) //undefined means that we do not know yet how many notifications there are
    const hasNewNotifications = computed(() => count.value ? count.value > 0 : false)

    function setNotificationsCount(value: number) {
        count.value = value
    }

    return {
        hasNewNotifications,
        setNotificationsCount
    }
})